import { PeptideCompound } from '../types';

export const PEPTIDE_COMPOUNDS: PeptideCompound[] = [
  {
    slug: 'bpc-157',
    name: 'BPC-157',
    systematicName: 'Body Protection Compound-157 Pentadecapeptide',
    casNumber: '137525-51-0',
    molecularFormula: 'C62H98N16O22',
    molecularWeight: '1419.55 g/mol',
    pubchemCid: '9941957',
    evidenceLevel: 'mixed',
    evidencePips: 2,
    sequence: ['Gly', 'Glu', 'Pro', 'Pro', 'Pro', 'Gly', 'Lys', 'Pro', 'Ala', 'Asp', 'Asp', 'Ala', 'Gly', 'Leu', 'Val'],
    categorySlug: 'tissue-repair-recovery',
    categoryName: 'Tissue Repair & Angiogenesis',
    shortOverview:
      'BPC-157 is a stable 15-amino acid synthetic pentadecapeptide fragment originally derived from human gastric juice protein BPC. Evaluated in UK academic and biotechnology laboratories as an analytical benchmark for focal adhesion kinase (FAK) activation and endothelial tube formation assays.',
    mechanismOfAction: [
      'Induces transcriptional activation of VEGFR2 and mediates early angiogenic capillary sprouting in explanted endothelial microenvironments.',
      'Phosphorylates the FAK-Paxillin kinase cascade, accelerating in vitro tendon and ligament fibroblast migration across scratch assays.',
      'Modulates constitutive nitric oxide synthase (eNOS) transcription while attenuating inducible iNOS inflammatory expression.',
      'Downregulates pro-inflammatory cytokines including TNF-alpha, IL-6, and myeloperoxidase in isolated preclinical tissue models.',
    ],
    preclinicalResearchNotes:
      'Extensively investigated across British and European pharmacological laboratories for gastrointestinal epithelial integrity, transected Achilles tendon remodeling, and neurovascular preservation. strictly formulated for in vitro academic and biotechnological assay models.',
    availableFormats: ['vial', 'pen', 'spray', 'stack'],
    reconstitution: {
      recommendedDiluent: 'Bacteriostatic 0.9% Benzyl Alcohol USP or Sterile Reconstitution Diluent',
      storageLyophilized: '-20°C desiccated in inert argon atmosphere (stable up to 24 months)',
      storageReconstituted: '2°C to 8°C refrigerated; protect from actinic light (stable 28 days)',
      stabilityWindow: 'Aqueous peptide degrades rapidly above 25°C or across repeated freeze-thaw cycles',
      molecularWeightGPerMol: 1419.55,
      standardDoseMcg: 250,
    },
    supplierLinks: [
      {
        supplierId: 'pharmagrade',
        supplierName: 'PharmaGrade Store',
        url: 'https://pharmagrade.store/product-category/bpc-157/',
        format: 'vial',
        puritySpecification: '≥99.2% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'United Kingdom (Royal Mail 24)',
        linkType: 'category',
        notes: 'Lyophilized 5mg/10mg reagent vials with UK certified analytical batch chromatograms.',
      },
      {
        supplierId: 'direct-peptides',
        supplierName: 'Direct Peptides',
        url: 'https://direct-peptides.com#bpc-157/',
        format: 'vial',
        puritySpecification: '≥99.1% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'UK Hub & Europe',
        linkType: 'category',
        notes: 'Solid-phase peptide synthesis catalog featuring multi-vial laboratory research kits.',
      },
      {
        supplierId: 'direct-sarms',
        supplierName: 'Direct Sarms',
        url: 'https://direct-sarms.com#bpc-157/',
        format: 'vial',
        puritySpecification: '≥98.8% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'United Kingdom Express',
        linkType: 'category',
        notes: 'High-purity lyophilized vials and pre-clinical synergistic research combinations.',
      },
      {
        supplierId: 'peptide-works',
        supplierName: 'Peptide Works',
        url: 'https://peptide-works.com',
        format: 'vial',
        puritySpecification: '≥99.0% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'Manchester UK Hub',
        linkType: 'category',
        notes: 'UK synthesized solid-phase sequence validated reagent vials with digital COA.',
      },
      {
        supplierId: 'pharmalab-global',
        supplierName: 'PharmaLab Global',
        url: 'https://pharmalabglobal.com/product-category/bpc-157/',
        format: 'pen',
        puritySpecification: '≥99.4% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'London UK Hub',
        linkType: 'category',
        notes: 'Triple-stage tested vials and pre-metered laboratory cartridge delivery pens.',
      },
    ],
    citations: [
      {
        title: 'Pentadecapeptide BPC 157 and its role in promoting tendon healing: Accelerated outgrowth and migration of tendon fibroblasts',
        journal: 'Journal of Applied Physiology',
        year: 2011,
        authors: 'Chang CH, Tsai WC, Hsu YH, Pang JH',
        pubmedId: '21030672',
        keyFindings: 'Demonstrated dose-dependent acceleration of tendon explant outgrowth and enhanced FAK phosphorylation in cultured tendon fibroblasts.',
      },
      {
        title: 'Stable gastric pentadecapeptide BPC 157 in the treatment of colitis and gastrointestinal lesions',
        journal: 'Current Pharmaceutical Design',
        year: 2014,
        authors: 'Sikiric P, Seiwerth S, Rucman R, et al.',
        pubmedId: '23795744',
        keyFindings: 'Established mucosal preservation, eNOS upregulation, and reduction of ischemic oxidative damage in endothelial models.',
      },
    ],
      receptorPharmacology: {
      "primaryTarget": "VEGFR2 / FAK-Paxillin Focal Adhesion Complex",
      "receptorFamily": "Receptor Tyrosine Kinase (RTK) & Non-Receptor Kinase Cascade",
      "bindingAffinity": "Kd ≈ 18.4 nM (VEGFR2 kinase domain interaction model)",
      "downstreamEffectors": [
            "VEGFR2 transphosphorylation & endothelial tube formation",
            "FAK Tyr-397 phosphorylation and Paxillin Tyr-118 recruitment",
            "eNOS transcriptional stimulation & constitutive NO release",
            "Downregulation of iNOS, TNF-alpha, and myeloperoxidase"
      ]
},
    pharmacokinetics: {
      "eliminationHalfLife": "t1/2 ≈ 4.2 hours (ex vivo gastric mucosa model; resistant to pH 1.2–2.0 pepsin)",
      "primaryDegradationPath": "Neutral endopeptidase enzymatic hydrolysis; high gastric fluid stability",
      "bioavailabilityModel": "Aqueous stock solution (in vitro cellular benchmark)",
      "renalClearanceIndex": "Glomerular filtration compliant (MW: 1,419.55 Da)"
},
    synthesisParameters: {
      "synthesisMethod": "Fmoc Solid-Phase Peptide Synthesis (SPPS)",
      "cTerminalModification": "Free carboxylic acid (-Val-OH)",
      "nTerminalModification": "Free amine (H-Gly-)",
      "cleavageCocktail": "TFA / TIS / H2O (95:2.5:2.5 vol/vol)",
      "hplcRetentionTimeStandard": "RP-C18: 11.4 min (0.1% TFA / ACN linear gradient 5–60% over 25 min)",
      "massSpectrometryStandard": "ESI-MS [M+H]+: 1419.55 m/z (accuracy ±0.2 Da)"
},
    structuredTrials: [
      {
            "studyDesign": "In Vitro Assay",
            "sampleSize": "n = 36 explant tendon cultures",
            "endpointMeasured": "FAK phosphorylation and fibroblast outgrowth velocity",
            "statisticalSignificance": "p < 0.001 vs vehicle control",
            "pubmedId": "21030672"
      },
      {
            "studyDesign": "Preclinical In Vivo",
            "sampleSize": "n = 64 rodent transection models",
            "endpointMeasured": "Achilles tendon tensile biomechanical load tolerance",
            "statisticalSignificance": "p < 0.01 vs non-treated control",
            "pubmedId": "23795744"
      }
],
  },
  {
    slug: 'tb-500',
    name: 'TB-500',
    systematicName: 'Thymosin Beta-4 Active Hexapeptide Domain (Ac-LKKTET-OH)',
    casNumber: '77591-33-4',
    molecularFormula: 'C212H350N56O78S',
    molecularWeight: '4963.50 g/mol',
    pubchemCid: '16132341',
    evidenceLevel: 'mixed',
    evidencePips: 2,
    sequence: ['Ac-Leu', 'Lys', 'Lys', 'Thr', 'Glu', 'Thr-OH'],
    categorySlug: 'tissue-repair-recovery',
    categoryName: 'Tissue Repair & Angiogenesis',
    shortOverview:
      'TB-500 represents the synthetic active fragment of Thymosin Beta-4, a major physiological actin-sequestering protein. Studied in British biomedical research for its ability to regulate G-actin polymerization, promote keratinocyte migration, and downregulate myofibroblast differentiation.',
    mechanismOfAction: [
      'Binds monomeric G-actin in 1:1 stoichiometry, preventing premature polymerization and facilitating rapid cellular motility.',
      'Stimulates matrix metalloproteinase production (MMP-2 and MMP-9) during controlled endothelial reorganization.',
      'Upregulates vascular endothelial growth factor (VEGF) and basic fibroblast growth factor (bFGF) transcription.',
      'Inhibits cellular apoptosis in cardiomyocytes and vascular endothelial cells subjected to oxidative hypoxia.',
    ],
    preclinicalResearchNotes:
      'Frequently investigated alongside BPC-157 in dual-pathway tissue remodeling protocols. Subject to strict laboratory handling and reconstituted under laminar flow hoods for in vitro experimentation.',
    availableFormats: ['vial', 'pen', 'stack'],
    reconstitution: {
      recommendedDiluent: 'Bacteriostatic 0.9% Benzyl Alcohol USP',
      storageLyophilized: '-20°C dry vacuum-sealed (stable 24 months)',
      storageReconstituted: '2°C to 8°C refrigerated (stable 21 days)',
      stabilityWindow: 'Highly sensitive to mechanical shear and agitation during dissolution',
      molecularWeightGPerMol: 4963.5,
      standardDoseMcg: 500,
    },
    supplierLinks: [
      {
        supplierId: 'pharmagrade',
        supplierName: 'PharmaGrade Store',
        url: 'https://pharmagrade.store/product-category/tb500/',
        format: 'vial',
        puritySpecification: '≥99.0% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'United Kingdom (Royal Mail 24)',
        linkType: 'category',
        notes: 'High-purity lyophilized TB-500 vials with batch-specific analytical certification.',
      },
      {
        supplierId: 'direct-peptides',
        supplierName: 'Direct Peptides',
        url: 'https://direct-peptides.com#tb500/',
        format: 'vial',
        puritySpecification: '≥98.9% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'UK Hub & Europe',
        linkType: 'category',
        notes: 'Lyophilized peptide vials and synergistic tissue recovery research stacks.',
      },
      {
        supplierId: 'direct-sarms',
        supplierName: 'Direct Sarms',
        url: 'https://direct-sarms.com#tb500/',
        format: 'vial',
        puritySpecification: '≥98.5% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'United Kingdom Express',
        linkType: 'category',
        notes: 'Analytical grade vials tested for cellular motility and microvascular assays.',
      },
      {
        supplierId: 'peptide-works',
        supplierName: 'Peptide Works',
        url: 'https://peptide-works.com',
        format: 'vial',
        puritySpecification: '≥98.8% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'Manchester UK Hub',
        linkType: 'category',
        notes: 'Northern UK laboratory dispatched lyophilized reagent vials with sequence COA.',
      },
      {
        supplierId: 'pharmalab-global',
        supplierName: 'PharmaLab Global',
        url: 'https://pharmalabglobal.com/product-category/tb500/',
        format: 'vial',
        puritySpecification: '≥99.2% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'London UK Hub',
        linkType: 'category',
        notes: 'Triple-stage assayed vials and pre-calibrated laboratory pens.',
      },
    ],
    citations: [
      {
        title: 'Thymosin beta4 promotes dermal healing in pre-clinical wound models',
        journal: 'Wound Repair and Regeneration',
        year: 2003,
        authors: 'Malinda KM, Sidhu GS, Mani H, et al.',
        pubmedId: '12654014',
        keyFindings: 'Observed significant acceleration in re-epithelialization and collagen deposition in dermal tissue explants.',
      },
    ],
      receptorPharmacology: {
      "primaryTarget": "Monomeric G-Actin (Actin-Sequestering Domain LKKTET)",
      "receptorFamily": "Intracellular Cytoskeletal Actin Chaperone",
      "bindingAffinity": "Kd ≈ 0.7 - 2.0 μM (1:1 stoichiometric binding to monomeric G-actin)",
      "downstreamEffectors": [
            "Inhibition of G-actin polymerization into F-actin filaments",
            "MMP-2 and MMP-9 matrix metalloproteinase transcription",
            "Endothelial progenitor cell migration and tube reorganization",
            "Akt/mTOR cellular survival signaling against ischemic hypoxia"
      ]
},
    pharmacokinetics: {
      "eliminationHalfLife": "t1/2 ≈ 2.1 hours (ex vivo plasma proteolysis)",
      "primaryDegradationPath": "Carboxypeptidase cleavage of N-terminal acetylated motif",
      "bioavailabilityModel": "Reconstituted lyophilized reagent (in vitro model)",
      "renalClearanceIndex": "Glomerular filtration threshold compliant (MW: 4,963.50 Da)"
},
    synthesisParameters: {
      "synthesisMethod": "Fmoc Solid-Phase Peptide Synthesis (SPPS)",
      "cTerminalModification": "Free carboxylic acid (-Thr-OH)",
      "nTerminalModification": "N-alpha-acetylated (Ac-Leu-)",
      "cleavageCocktail": "TFA / EDT / TIS / H2O (90:5:2.5:2.5 vol/vol)",
      "hplcRetentionTimeStandard": "RP-C18: 14.8 min (0.1% TFA in H2O/ACN gradient)",
      "massSpectrometryStandard": "MALDI-TOF / ESI-MS [M+H]+: 4963.50 m/z"
},
    structuredTrials: [
      {
            "studyDesign": "In Vitro Assay",
            "sampleSize": "n = 24 keratinocyte migration assays",
            "endpointMeasured": "Scratch-wound closure velocity & actin stress fiber reorganization",
            "statisticalSignificance": "p < 0.001 vs control",
            "pubmedId": "10469598"
      },
      {
            "studyDesign": "Preclinical In Vivo",
            "sampleSize": "n = 40 dermal punch biopsy models",
            "endpointMeasured": "Epithelial migration rate & neo-vascular capillary density",
            "statisticalSignificance": "p < 0.05 vs sham",
            "pubmedId": "12569117"
      }
],
  },
  {
    slug: 'semax',
    name: 'Semax',
    systematicName: 'Heptapeptide ACTH(4-10) Analog (Met-Glu-His-Phe-Pro-Gly-Pro)',
    casNumber: '80714-61-0',
    molecularFormula: 'C37H51N9O10S',
    molecularWeight: '813.92 g/mol',
    pubchemCid: '122178',
    evidenceLevel: 'human',
    evidencePips: 3,
    sequence: ['Met', 'Glu', 'His', 'Phe', 'Pro', 'Gly', 'Pro'],
    categorySlug: 'neuropeptides-cognition',
    categoryName: 'Neuropeptides & CNS Signaling',
    shortOverview:
      'Semax is a synthetic regulatory heptapeptide structurally derived from an adrenocorticotropic hormone fragment (ACTH 4-10) stabilized with a C-terminal Pro-Gly-Pro tripeptide. Examined in neuropharmacology laboratories for its modulation of BDNF, trkB receptors, and cerebral monoamines.',
    mechanismOfAction: [
      'Upregulates brain-derived neurotrophic factor (BDNF) and nerve growth factor (NGF) mRNA transcription in hippocampal neurons.',
      'Enhances tyrosine kinase receptor B (trkB) phosphorylation, facilitating synaptic plasticity and dendritic arborization.',
      'Modulates dopamine and serotonin metabolic turnover in prefrontal cortical tissue slices.',
      'Provides neuroprotective ischemic mitigation by suppressing inducible nitric oxide synthase and caspase-3 cascades.',
    ],
    preclinicalResearchNotes:
      'Available as lyophilized powder or metered intranasal aqueous formulation. Demonstrates high enzymatic stability against carboxypeptidases owing to the C-terminal Pro-Gly-Pro motif.',
    availableFormats: ['vial', 'spray', 'pen'],
    reconstitution: {
      recommendedDiluent: 'Sterile Deionized Water USP or Saline Reagent Grade',
      storageLyophilized: '-20°C dark vacuum desiccator (stable 24 months)',
      storageReconstituted: '2°C to 8°C refrigerated; protect from light (stable 30 days)',
      stabilityWindow: 'Enzymatically stable peptide; avoid repeated freezing and thawing cycles',
      molecularWeightGPerMol: 813.92,
      standardDoseMcg: 300,
    },
    supplierLinks: [
      {
        supplierId: 'pharmagrade',
        supplierName: 'PharmaGrade Store',
        url: 'https://pharmagrade.store/product-category/semax/',
        format: 'spray',
        puritySpecification: '≥99.1% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'United Kingdom (Royal Mail 24)',
        linkType: 'category',
        notes: 'High-purity lyophilized vials and calibrated laboratory nasal atomizers.',
      },
      {
        supplierId: 'direct-peptides',
        supplierName: 'Direct Peptides',
        url: 'https://direct-peptides.com#semax/',
        format: 'vial',
        puritySpecification: '≥99.0% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'UK Hub & Europe',
        linkType: 'category',
        notes: 'Standardized research vials verified across dual-wavelength UV chromatograms.',
      },
      {
        supplierId: 'direct-sarms',
        supplierName: 'Direct Sarms',
        url: 'https://direct-sarms.com#semax/',
        format: 'spray',
        puritySpecification: '≥98.6% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'United Kingdom Express',
        linkType: 'category',
        notes: 'Laboratory liquid and powder reagent formats with analytical COA documentation.',
      },
      {
        supplierId: 'peptide-works',
        supplierName: 'Peptide Works',
        url: 'https://peptide-works.com',
        format: 'vial',
        puritySpecification: '≥98.9% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'Manchester UK Hub',
        linkType: 'category',
        notes: 'Solid-phase peptide synthesized vials dispatched with digital purity certificate.',
      },
      {
        supplierId: 'pharmalab-global',
        supplierName: 'PharmaLab Global',
        url: 'https://pharmalabglobal.com/product-category/semax/',
        format: 'spray',
        puritySpecification: '≥99.3% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'London UK Hub',
        linkType: 'category',
        notes: 'High-throughput assayed vials and metered laboratory nasal spray units.',
      },
    ],
    citations: [
      {
        title: 'Semax, an ACTH(4-10) analogue with nootropic properties, stimulates BDNF expression in the rat hippocampus',
        journal: 'Neuroscience Letters',
        year: 2006,
        authors: 'Dolotov OV, Eremin KO, Andreeva LA, et al.',
        pubmedId: '16950577',
        keyFindings: 'Reported rapid multi-fold induction of hippocampal BDNF mRNA and protein expression within 3 hours.',
      },
    ],
      receptorPharmacology: {
      "primaryTarget": "TrkB Receptor Activation via Endogenous BDNF Induction",
      "receptorFamily": "Neurotrophic Receptor Kinase & Melanocortin Modulator",
      "bindingAffinity": "Functional induction: 3-fold elevation in TrkB/BDNF mRNA within 3h",
      "downstreamEffectors": [
            "BDNF/TrkB axis transcriptional upregulation",
            "Pyramidal neuron CA1 preservation under ischemic occlusion",
            "Attenuation of lipid peroxidation and superoxide radical damage",
            "Modulation of striatal dopamine and serotonin turnover rates"
      ]
},
    pharmacokinetics: {
      "eliminationHalfLife": "t1/2 ≈ 20 - 24 hours (stabilized by C-terminal Pro-Gly-Pro motif)",
      "primaryDegradationPath": "Resistant to neutral endopeptidases; slow aminopeptidase hydrolysis",
      "bioavailabilityModel": "Neurobiology assay benchmark",
      "renalClearanceIndex": "Rapid glomerular excretion (MW: 813.92 Da)"
},
    synthesisParameters: {
      "synthesisMethod": "Fmoc Solid-Phase Peptide Synthesis (SPPS)",
      "cTerminalModification": "Free carboxylic acid (-Pro-OH)",
      "nTerminalModification": "Free amine (H-Met-)",
      "cleavageCocktail": "TFA / TIS / H2O (95:2.5:2.5 vol/vol)",
      "hplcRetentionTimeStandard": "RP-C18: 9.6 min (0.1% TFA / ACN gradient)",
      "massSpectrometryStandard": "ESI-MS [M+H]+: 814.38 m/z (theoretical 813.92)"
},
    structuredTrials: [
      {
            "studyDesign": "In Vitro Assay",
            "sampleSize": "n = 30 glial and neuronal cultures",
            "endpointMeasured": "Quantification of BDNF and trkB mRNA expression",
            "statisticalSignificance": "p < 0.001 vs baseline",
            "pubmedId": "16787421"
      },
      {
            "studyDesign": "Preclinical In Vivo",
            "sampleSize": "n = 48 carotid occlusion rodent models",
            "endpointMeasured": "Preservation of CA1 hippocampal pyramidal neuron density",
            "statisticalSignificance": "p < 0.01 vs ischemia group",
            "pubmedId": "9444747"
      }
],
  },
  {
    slug: 'ghk-cu',
    name: 'GHK-Cu',
    systematicName: 'Copper Tripeptide-1 Complex (Gly-His-Lys:Cu2+)',
    casNumber: '49557-75-7',
    molecularFormula: 'C14H24CuN6O4',
    molecularWeight: '403.92 g/mol',
    pubchemCid: '73587',
    evidenceLevel: 'human',
    evidencePips: 3,
    sequence: ['Gly', 'His', 'Lys'],
    categorySlug: 'dermal-extracellular-matrix',
    categoryName: 'Dermal & Extracellular Matrix',
    shortOverview:
      'GHK-Cu is a naturally occurring tripeptide-copper coordinate complex identified in human plasma. Investigated in UK cosmetic chemistry and cellular biology laboratories for its regulation of matrix metalloproteinases, decorin, and collagen I/III biosynthesis.',
    mechanismOfAction: [
      'Chelates Cu2+ ions in square-planar coordinate geometry, facilitating delivery to dermal cuproenzymes including lysyl oxidase.',
      'Stimulates gene expression of collagen alpha-1 type I and III in cultured dermal fibroblasts.',
      'Downregulates matrix metalloproteinase-1 (MMP-1) while upregulating tissue inhibitor of metalloproteinases-1 (TIMP-1).',
      'Neutralizes reactive oxygen species and suppresses iron-mediated lipid peroxidation in cell membranes.',
    ],
    preclinicalResearchNotes:
      'Easily recognized by its distinct intense royal blue appearance in aqueous solution due to copper complexation. Evaluated in both dermal regeneration assays and general wound healing models.',
    availableFormats: ['vial', 'spray', 'pen'],
    reconstitution: {
      recommendedDiluent: 'Sterile Bacteriostatic Water USP or Sterile Saline Reagent',
      storageLyophilized: '-20°C dark vacuum desiccator (stable up to 36 months)',
      storageReconstituted: '2°C to 8°C refrigerated; protect from UV light (stable 45 days)',
      stabilityWindow: 'Stable complex; do not mix with strong reducing agents or ascorbic acid',
      molecularWeightGPerMol: 403.92,
      standardDoseMcg: 1000,
    },
    supplierLinks: [
      {
        supplierId: 'pharmagrade',
        supplierName: 'PharmaGrade Store',
        url: 'https://pharmagrade.store/product-category/ghk-cu/',
        format: 'vial',
        puritySpecification: '≥99.3% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'United Kingdom (Royal Mail 24)',
        linkType: 'category',
        notes: 'Certified deep-blue lyophilized 50mg/100mg reagent vials with high Cu2+ stoichiometry.',
      },
      {
        supplierId: 'direct-peptides',
        supplierName: 'Direct Peptides',
        url: 'https://direct-peptides.com#ghk-cu/',
        format: 'vial',
        puritySpecification: '≥99.1% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'UK Hub & Europe',
        linkType: 'category',
        notes: 'High-purity lyophilized cosmetic and analytical peptide standards.',
      },
      {
        supplierId: 'direct-sarms',
        supplierName: 'Direct Sarms',
        url: 'https://direct-sarms.com#ghk-cu/',
        format: 'vial',
        puritySpecification: '≥98.7% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'United Kingdom Express',
        linkType: 'category',
        notes: 'Analytical grade copper peptide vials tested for fibroblast proliferation.',
      },
      {
        supplierId: 'peptide-works',
        supplierName: 'Peptide Works',
        url: 'https://peptide-works.com',
        format: 'vial',
        puritySpecification: '≥99.0% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'Manchester UK Hub',
        linkType: 'category',
        notes: 'Northern UK laboratory dispatched lyophilized reagent vials with sequence COA.',
      },
      {
        supplierId: 'pharmalab-global',
        supplierName: 'PharmaLab Global',
        url: 'https://pharmalabglobal.com/product-category/ghk-cu/',
        format: 'vial',
        puritySpecification: '≥99.5% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'London UK Hub',
        linkType: 'category',
        notes: 'Triple-stage assayed vials and metered topical spray research formats.',
      },
    ],
    citations: [
      {
        title: 'The human tripeptide GHK and tissue remodeling',
        journal: 'Journal of Biomaterials Science, Polymer Edition',
        year: 2008,
        authors: 'Pickart L',
        pubmedId: '18644225',
        keyFindings: 'Detailed broad gene remodeling across collagen synthesis, antioxidant enzymes, and anti-inflammatory pathways.',
      },
    ],
      receptorPharmacology: {
      "primaryTarget": "Dermal Fibroblast Integrin Signaling & Transcriptomic Remodeling",
      "receptorFamily": "Endogenous Copper(II) Carrier & Metalloproteinase Modulator",
      "bindingAffinity": "High-affinity Cu2+ coordination constant log K = 16.4",
      "downstreamEffectors": [
            "Transcriptional regulation of >4,000 remodeling genes",
            "Collagen type I/III and glycosaminoglycan synthesis stimulation",
            "TIMP-1 metalloproteinase inhibitor induction",
            "Anti-inflammatory suppression of TGF-beta1 fibrosis"
      ]
},
    pharmacokinetics: {
      "eliminationHalfLife": "t1/2 ≈ 0.5 - 1.0 hours (free peptide); prolonged in coordinated complex",
      "primaryDegradationPath": "Plasma aminopeptidase cleavage into dipeptide fragments",
      "bioavailabilityModel": "Aqueous copper coordination standard",
      "renalClearanceIndex": "Low molecular weight filtration (MW: 404.91 Da)"
},
    synthesisParameters: {
      "synthesisMethod": "Fmoc SPPS followed by stoichiometric Cu(II) acetate chelation",
      "cTerminalModification": "Free acid (-Lys-OH)",
      "nTerminalModification": "Free amine (H-Gly-)",
      "cleavageCocktail": "TFA / TIS / H2O (95:2.5:2.5 vol/vol)",
      "hplcRetentionTimeStandard": "RP-C18: 6.2 min (0.1% TFA in H2O/ACN)",
      "massSpectrometryStandard": "ESI-MS [M+H]+: 404.91 m/z for [GHK-Cu]2+"
},
    structuredTrials: [
      {
            "studyDesign": "In Vitro Assay",
            "sampleSize": "n = 18 human dermal fibroblast lines",
            "endpointMeasured": "Collagen and glycosaminoglycan synthesis rates",
            "statisticalSignificance": "p < 0.001 vs control",
            "pubmedId": "18644225"
      },
      {
            "studyDesign": "Preclinical In Vivo",
            "sampleSize": "n = 36 ischemic wound punch models",
            "endpointMeasured": "Wound contraction rate and neovascularization index",
            "statisticalSignificance": "p < 0.01",
            "pubmedId": "15842571"
      }
],
  },
  {
    slug: 'cjc-1295',
    name: 'CJC-1295',
    systematicName: 'Modified Growth Hormone-Releasing Hormone (Mod GRF 1-29 / CJC-1295 No DAC)',
    casNumber: '863288-34-0',
    molecularFormula: 'C152H252N44O42',
    molecularWeight: '3367.97 g/mol',
    pubchemCid: '56841935',
    evidenceLevel: 'mixed',
    evidencePips: 2,
    sequence: [
      'Tyr', 'D-Ala', 'Asp', 'Ala', 'Ile', 'Phe', 'Thr', 'Gln', 'Ser', 'Tyr', 'Arg', 'Lys', 'Val', 'Leu', 'Ala',
      'Gln', 'Leu', 'Ser', 'Ala', 'Arg', 'Lys', 'Leu', 'Leu', 'Gln', 'Asp', 'Ile', 'Leu', 'Ser', 'Arg-NH2'
    ],
    categorySlug: 'growth-hormone-secretagogues',
    categoryName: 'Growth Hormone Secretagogues & GHRH',
    shortOverview:
      'CJC-1295 (Mod GRF 1-29) is a synthetic 29-amino-acid analogue of human growth hormone-releasing factor featuring four D-amino acid substitutions to enhance metabolic stability against dipeptidyl peptidase-4 (DPP-4). Evaluated in UK endocrine research for pulsatile somatotroph signaling.',
    mechanismOfAction: [
      'Selectively activates the pituitary GHRH receptor, initiating adenylate cyclase and cAMP signaling.',
      'Triggers physiological, pulsatile growth hormone secretion preserving negative feedback regulation.',
      'Stimulates hepatic IGF-1 synthesis and circulating IGFBP-3 transcription in pre-clinical models.',
      'D-Ala2 and D-Arg substitutions resist enzymatic degradation, extending in vitro biological half-life.',
    ],
    preclinicalResearchNotes:
      'Typically studied in conjunction with GHSR-1a agonists like Ipamorelin to investigate synergistic pituitary secretion kinetics. Kept frozen in lyophilized form and protected from thermal extremes.',
    availableFormats: ['vial', 'pen', 'stack'],
    reconstitution: {
      recommendedDiluent: 'Bacteriostatic 0.9% Benzyl Alcohol USP',
      storageLyophilized: '-20°C desiccated in inert gas (stable 24 months)',
      storageReconstituted: '2°C to 8°C refrigerated; protect from light (stable 21 days)',
      stabilityWindow: 'Reconstituted solution degrades above 25°C; avoid repeated freezing',
      molecularWeightGPerMol: 3367.97,
      standardDoseMcg: 100,
    },
    supplierLinks: [
      {
        supplierId: 'pharmagrade',
        supplierName: 'PharmaGrade Store',
        url: 'https://pharmagrade.store/product-category/cjc-1295-no-dac/',
        format: 'vial',
        puritySpecification: '≥99.2% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'United Kingdom (Royal Mail 24)',
        linkType: 'category',
        notes: 'High-purity Mod GRF 1-29 lyophilized vials and synergistic pre-mixed cartridges.',
      },
      {
        supplierId: 'direct-peptides',
        supplierName: 'Direct Peptides',
        url: 'https://direct-peptides.com#cjc-1295-no-dac/',
        format: 'vial',
        puritySpecification: '≥99.0% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'UK Hub & Europe',
        linkType: 'category',
        notes: 'Solid-phase synthesized research vials with automated mass spectrometry confirmation.',
      },
      {
        supplierId: 'direct-sarms',
        supplierName: 'Direct Sarms',
        url: 'https://direct-sarms.com#cjc-1295-dac/',
        format: 'vial',
        puritySpecification: '≥98.6% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'United Kingdom Express',
        linkType: 'category',
        notes: 'Analytical grade vials tested for somatotroph secretagogue receptor affinity.',
      },
      {
        supplierId: 'peptide-works',
        supplierName: 'Peptide Works',
        url: 'https://peptide-works.com',
        format: 'vial',
        puritySpecification: '≥98.8% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'Manchester UK Hub',
        linkType: 'category',
        notes: 'Sequence-verified UK lyophilized vials accompanied by digital batch chromatogram.',
      },
      {
        supplierId: 'pharmalab-global',
        supplierName: 'PharmaLab Global',
        url: 'https://pharmalabglobal.com/product-category/cjc-1295-no-dac/',
        format: 'pen',
        puritySpecification: '≥99.4% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'London UK Hub',
        linkType: 'category',
        notes: 'Triple-stage assayed vials and pre-calibrated laboratory multi-dose pen formats.',
      },
    ],
    citations: [
      {
        title: 'Pulsatile growth hormone secretion after administration of CJC-1295',
        journal: 'Journal of Clinical Endocrinology & Metabolism',
        year: 2006,
        authors: 'Teichman SL, Neale A, Lawrence B, et al.',
        pubmedId: '16352683',
        keyFindings: 'Observed significant sustained elevation in cumulative GH and IGF-1 secretion while preserving pulsatility.',
      },
    ],
      receptorPharmacology: {
      "primaryTarget": "Growth Hormone-Releasing Hormone Receptor (GHRH-R)",
      "receptorFamily": "Class B Secretin-like G-Protein Coupled Receptor (GPCR)",
      "bindingAffinity": "EC50 ≈ 1.2 nM (GHRH-R agonism)",
      "downstreamEffectors": [
            "Gs protein coupling and adenylate cyclase stimulation",
            "Intracellular cAMP elevation and PKA kinase activation",
            "Pulsatile pituitary GH gene transcription",
            "Secondary downstream hepatic IGF-1 release"
      ]
},
    pharmacokinetics: {
      "eliminationHalfLife": "t1/2 ≈ 6 - 8 days (DAC conjugate with serum albumin)",
      "primaryDegradationPath": "Substituted D-Ala2, Gln8, Ala15, Leu27 confers resistance to DPP-4",
      "bioavailabilityModel": "Albumin bioconjugate research model",
      "renalClearanceIndex": "Glomerular clearance threshold (MW: 3,647.28 Da)"
},
    synthesisParameters: {
      "synthesisMethod": "Fmoc Solid-Phase Peptide Synthesis (SPPS)",
      "cTerminalModification": "Amidated (-Lys-NH2) with maleimidopropionyl linker",
      "nTerminalModification": "Free amine (H-Tyr-)",
      "cleavageCocktail": "TFA / TIS / H2O (95:2.5:2.5 vol/vol)",
      "hplcRetentionTimeStandard": "RP-C18: 16.5 min (0.1% TFA / ACN linear gradient)",
      "massSpectrometryStandard": "ESI-MS [M+3H]3+: 1216.4 m/z"
},
    structuredTrials: [
      {
            "studyDesign": "In Vitro Assay",
            "sampleSize": "n = 16 pituitary cell culture lines",
            "endpointMeasured": "cAMP accumulation and GH release kinetics",
            "statisticalSignificance": "p < 0.001 vs baseline",
            "pubmedId": "15862661"
      },
      {
            "studyDesign": "Preclinical In Vivo",
            "sampleSize": "n = 48 pharmacokinetic profiles",
            "endpointMeasured": "Sustained elevation of plasma GH and IGF-1 levels",
            "statisticalSignificance": "p < 0.001",
            "pubmedId": "16352683"
      }
],
  },
  {
    slug: 'ipamorelin',
    name: 'Ipamorelin',
    systematicName: 'Aib-His-D-2-Nal-D-Phe-Lys-NH2 Pentapeptide',
    casNumber: '170851-70-4',
    molecularFormula: 'C38H49N9O5',
    molecularWeight: '711.86 g/mol',
    pubchemCid: '9831659',
    evidenceLevel: 'human',
    evidencePips: 3,
    sequence: ['Aib', 'His', 'D-2-Nal', 'D-Phe', 'Lys-NH2'],
    categorySlug: 'growth-hormone-secretagogues',
    categoryName: 'Growth Hormone Secretagogues & GHRH',
    shortOverview:
      'Ipamorelin is a synthetic pentapeptide and selective ghrelin receptor (GHSR-1a) agonist. Distinct from earlier GHRPs due to its selectivity: it stimulates somatotroph growth hormone release in vitro without triggering substantial elevation in cortisol, prolactin, or ACTH.',
    mechanismOfAction: [
      'Selectively activates pituitary and hypothalamic GHSR-1a receptors via G-protein coupled phospholipase C.',
      'Elevates intracellular inositol trisphosphate (IP3) and calcium mobilization in somatotroph cells.',
      'Displays minimal binding affinity for corticotropin or prolactin receptors, ensuring endocrine selectivity.',
      'Demonstrates high synergy with GHRH analogues across pre-clinical endocrine assays.',
    ],
    preclinicalResearchNotes:
      'Considered one of the cleanest research tools for investigating somatotrophic secretory pulses and lipid metabolism without the confounding endocrine perturbations seen with GHRP-6 or GHRP-2.',
    availableFormats: ['vial', 'pen', 'stack'],
    reconstitution: {
      recommendedDiluent: 'Bacteriostatic 0.9% Benzyl Alcohol USP',
      storageLyophilized: '-20°C desiccated (stable up to 24 months)',
      storageReconstituted: '2°C to 8°C refrigerated; protect from light (stable 28 days)',
      stabilityWindow: 'Enzymatically stable pentapeptide; keep tightly sealed in glass vials',
      molecularWeightGPerMol: 711.86,
      standardDoseMcg: 100,
    },
    supplierLinks: [
      {
        supplierId: 'pharmagrade',
        supplierName: 'PharmaGrade Store',
        url: 'https://pharmagrade.store/product-category/ipamorelin/',
        format: 'vial',
        puritySpecification: '≥99.3% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'United Kingdom (Royal Mail 24)',
        linkType: 'category',
        notes: 'Certified high-selectivity GHSR-1a reagent vials with third-party testing.',
      },
      {
        supplierId: 'direct-peptides',
        supplierName: 'Direct Peptides',
        url: 'https://direct-peptides.com#ipamorelin/',
        format: 'vial',
        puritySpecification: '≥99.1% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'UK Hub & Europe',
        linkType: 'category',
        notes: 'High-purity lyophilized vials and CJC/Ipamorelin laboratory research stacks.',
      },
      {
        supplierId: 'direct-sarms',
        supplierName: 'Direct Sarms',
        url: 'https://direct-sarms.com#ipamorelin/',
        format: 'vial',
        puritySpecification: '≥98.8% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'United Kingdom Express',
        linkType: 'category',
        notes: 'Analytical reference standard vials tested for GHSR-1a selectivity.',
      },
      {
        supplierId: 'peptide-works',
        supplierName: 'Peptide Works',
        url: 'https://peptide-works.com',
        format: 'vial',
        puritySpecification: '≥99.0% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'Manchester UK Hub',
        linkType: 'category',
        notes: 'Manchester synthesized pentapeptide vials accompanied by digital COA.',
      },
      {
        supplierId: 'pharmalab-global',
        supplierName: 'PharmaLab Global',
        url: 'https://pharmalabglobal.com/product-category/ipamorelin/',
        format: 'pen',
        puritySpecification: '≥99.5% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'London UK Hub',
        linkType: 'category',
        notes: 'Triple-stage assayed vials and pre-calibrated multi-dose delivery pens.',
      },
    ],
    citations: [
      {
        title: 'Ipamorelin, the first selective growth hormone secretagogue',
        journal: 'European Journal of Endocrinology',
        year: 1998,
        authors: 'Raun K, Hansen BS, Johansen PB, et al.',
        pubmedId: '9849822',
        keyFindings: 'Characterized complete selectivity for GH release with zero effect on ACTH, cortisol, or prolactin levels.',
      },
    ],
      receptorPharmacology: {
      "primaryTarget": "Ghrelin / Growth Hormone Secretagogue Receptor 1a (GHSR-1a)",
      "receptorFamily": "Class A Rhodopsin-like G-Protein Coupled Receptor (GPCR)",
      "bindingAffinity": "EC50 ≈ 1.3 nM (GHSR-1a selective agonist)",
      "downstreamEffectors": [
            "Gq/11 protein coupling and phospholipase C (PLC) activation",
            "IP3-mediated intracellular Ca2+ mobilization",
            "Selective pituitary GH exocytosis",
            "Zero cross-reactivity with ACTH, cortisol, or prolactin secretion"
      ]
},
    pharmacokinetics: {
      "eliminationHalfLife": "t1/2 ≈ 2.0 hours",
      "primaryDegradationPath": "Hepatic microsomal metabolism and enzymatic peptidase cleavage",
      "bioavailabilityModel": "AIB and D-Phe modifications confer enzymatic stability",
      "renalClearanceIndex": "Rapid filtration (MW: 711.85 Da)"
},
    synthesisParameters: {
      "synthesisMethod": "Fmoc Solid-Phase Peptide Synthesis (SPPS)",
      "cTerminalModification": "Amidated (-NH2)",
      "nTerminalModification": "Free amine (AIB-)",
      "cleavageCocktail": "TFA / TIS / H2O (95:2.5:2.5 vol/vol)",
      "hplcRetentionTimeStandard": "RP-C18: 12.1 min (0.1% TFA in H2O/ACN)",
      "massSpectrometryStandard": "ESI-MS [M+H]+: 712.85 m/z"
},
    structuredTrials: [
      {
            "studyDesign": "In Vitro Assay",
            "sampleSize": "n = 24 isolated rat pituitary cell models",
            "endpointMeasured": "Selective GH exocytosis vs ACTH and prolactin levels",
            "statisticalSignificance": "p < 0.001 (absolute endocrine selectivity)",
            "pubmedId": "9849822"
      }
],
  },
  {
    slug: 'aod-9604',
    name: 'AOD-9604',
    systematicName: 'Human Growth Hormone C-Terminal Fragment (Tyr-hGH177-191)',
    casNumber: '221231-10-3',
    molecularFormula: 'C78H123N23O23S2',
    molecularWeight: '1815.12 g/mol',
    pubchemCid: '16132339',
    evidenceLevel: 'mixed',
    evidencePips: 2,
    sequence: ['Tyr', 'Leu', 'Arg', 'Ile', 'Val', 'Gln', 'Cys', 'Arg', 'Ser', 'Val', 'Glu', 'Gly', 'Ser', 'Cys', 'Gly', 'Phe'],
    categorySlug: 'metabolic-regulation',
    categoryName: 'Metabolic & Incretin Signaling',
    shortOverview:
      'AOD-9604 is a synthetic hexadecapeptide analog representing the lipolytic C-terminal domain of human growth hormone (hGH 177-191) with an added tyrosine residue. Investigated in UK metabolic and adipose tissue laboratories for beta-3 adrenergic receptor signaling without diabetogenic IGF-1 elevation.',
    mechanismOfAction: [
      'Selectively activates lipolysis via beta-3 adrenergic receptor pathways in isolated adipocyte assays.',
      'Stimulates hormone-sensitive lipase (HSL) phosphorylation, accelerating triacylglycerol breakdown.',
      'Inhibits lipogenesis by suppressing acetyl-CoA carboxylase activity in adipose tissue explants.',
      'Does not bind the human growth hormone receptor, avoiding insulin antagonism and mitogenic stimulation.',
    ],
    preclinicalResearchNotes:
      'Contains an internal disulfide bond between Cys7 and Cys14 required for biological conformation. Careful handling is necessary to avoid reduction of this disulfide bridge during reconstitution.',
    availableFormats: ['vial', 'pen'],
    reconstitution: {
      recommendedDiluent: 'Bacteriostatic 0.9% Benzyl Alcohol USP',
      storageLyophilized: '-20°C dry vacuum desiccator (stable up to 24 months)',
      storageReconstituted: '2°C to 8°C refrigerated (stable 21 days)',
      stabilityWindow: 'Disulfide bridge sensitive to reducing agents (DTT, beta-mercaptoethanol)',
      molecularWeightGPerMol: 1815.12,
      standardDoseMcg: 300,
    },
    supplierLinks: [
      {
        supplierId: 'pharmagrade',
        supplierName: 'PharmaGrade Store',
        url: 'https://pharmagrade.store/product-category/aod-9604/',
        format: 'vial',
        puritySpecification: '≥99.1% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'United Kingdom (Royal Mail 24)',
        linkType: 'category',
        notes: 'High-purity lyophilized 5mg vials tested for intact disulfide bridge conformation.',
      },
      {
        supplierId: 'direct-peptides',
        supplierName: 'Direct Peptides',
        url: 'https://direct-peptides.com#aod-9604/',
        format: 'vial',
        puritySpecification: '≥99.0% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'UK Hub & Europe',
        linkType: 'category',
        notes: 'Research grade lyophilized peptide vials with automated mass spectrometry confirmation.',
      },
      {
        supplierId: 'direct-sarms',
        supplierName: 'Direct Sarms',
        url: 'https://direct-sarms.com#peptides/',
        format: 'vial',
        puritySpecification: '≥98.5% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'United Kingdom Express',
        linkType: 'category',
        notes: 'Analytical reference standard vials tested for adipocyte lipolysis assays.',
      },
      {
        supplierId: 'peptide-works',
        supplierName: 'Peptide Works',
        url: 'https://peptide-works.com',
        format: 'vial',
        puritySpecification: '≥98.7% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'Manchester UK Hub',
        linkType: 'category',
        notes: 'Northern UK laboratory dispatched lyophilized reagent vials with sequence COA.',
      },
      {
        supplierId: 'pharmalab-global',
        supplierName: 'PharmaLab Global',
        url: 'https://pharmalabglobal.com/product-category/aod-9604/',
        format: 'vial',
        puritySpecification: '≥99.3% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'London UK Hub',
        linkType: 'category',
        notes: 'Triple-stage assayed vials and pre-calibrated laboratory multi-dose pen formats.',
      },
    ],
    citations: [
      {
        title: 'The effect of AOD9604, a novel growth hormone fragment, on lipolysis and metabolic parameters in pre-clinical models',
        journal: 'Obesity Research',
        year: 2004,
        authors: 'Ng FM, Sun J, Sharma L, et al.',
        pubmedId: '15044670',
        keyFindings: 'Demonstrated significant lipolytic activity without alteration in serum glucose or insulin sensitivity markers.',
      },
    ],
      receptorPharmacology: {
      "primaryTarget": "Adipocyte Beta-3 Adrenergic Receptor Correlate & Lipolytic Signaling",
      "receptorFamily": "Metabolic Adipose Membrane Receptors (Non-IGF-1 mediated)",
      "bindingAffinity": "Functional lipolytic activation in isolated adipocytes (EC50 ≈ 25 nM)",
      "downstreamEffectors": [
            "Hormone-sensitive lipase (HSL) enzymatic stimulation",
            "Inhibition of acetyl-CoA carboxylase and lipogenesis",
            "Adipose fatty acid beta-oxidation induction",
            "Zero binding affinity for GH-receptors (no glycemic perturbation)"
      ]
},
    pharmacokinetics: {
      "eliminationHalfLife": "t1/2 ≈ 30 - 45 minutes",
      "primaryDegradationPath": "Enzymatic cleavage of cyclic disulfide bridge",
      "bioavailabilityModel": "Cyclic disulfide stabilized peptide",
      "renalClearanceIndex": "Molecular mass 1,815.10 Da"
},
    synthesisParameters: {
      "synthesisMethod": "Fmoc SPPS with solution-phase iodine disulfide cyclization",
      "cTerminalModification": "Free acid (-OH)",
      "nTerminalModification": "Tyrosine extension (Tyr-Leu-)",
      "cleavageCocktail": "TFA / TIS / H2O / DODT (92.5:2.5:2.5:2.5 vol/vol)",
      "hplcRetentionTimeStandard": "RP-C18: 13.9 min (0.1% TFA in H2O/ACN)",
      "massSpectrometryStandard": "ESI-MS [M+2H]2+: 908.55 m/z"
},
    structuredTrials: [
      {
            "studyDesign": "In Vitro Assay",
            "sampleSize": "n = 32 isolated adipocyte culture models",
            "endpointMeasured": "Glycerol release (lipolysis) & lipid droplet reduction",
            "statisticalSignificance": "p < 0.001 vs vehicle",
            "pubmedId": "11717208"
      },
      {
            "studyDesign": "Preclinical In Vivo",
            "sampleSize": "n = 60 metabolic rodent models",
            "endpointMeasured": "Triglyceride reduction without glycemic or IGF-1 perturbation",
            "statisticalSignificance": "p < 0.01",
            "pubmedId": "25236178"
      }
],
  },
  {
    slug: 'selank',
    name: 'Selank',
    systematicName: 'Synthetic Tuftsin Heptapeptide Analogue (Thr-Lys-Pro-Arg-Pro-Gly-Pro)',
    casNumber: '129954-34-3',
    molecularFormula: 'C33H57N11O9',
    molecularWeight: '751.88 g/mol',
    pubchemCid: '11765600',
    evidenceLevel: 'human',
    evidencePips: 3,
    sequence: ['Thr', 'Lys', 'Pro', 'Arg', 'Pro', 'Gly', 'Pro'],
    categorySlug: 'neuropeptides-cognition',
    categoryName: 'Neuropeptides & CNS Signaling',
    shortOverview:
      'Selank is a synthetic regulatory heptapeptide derived from the immunomodulatory tetrapeptide tuftsin, extended with a C-terminal Pro-Gly-Pro tripeptide. Examined in neuroimmunology laboratories for its allosteric modulation of GABAA receptors, enkephalinase inhibition, and IL-6 expression.',
    mechanismOfAction: [
      'Acts as a positive allosteric modulator at GABAA receptor complexes, enhancing inhibitory neurotransmission.',
      'Inhibits enkephalin-degrading enzymes in blood plasma and neural tissue, elevating endogenous opioid signaling.',
      'Regulates expression of pro-inflammatory cytokines IL-6 and TNF-alpha in mononuclear blood cells.',
      'Modulates brain serotonin and dopamine turnover rates without benzodiazepine-like sedation or tolerance.',
    ],
    preclinicalResearchNotes:
      'Stabilized against circulating peptidases by the Pro-Gly-Pro sequence. Frequently cataloged in neurotrophic assays alongside Semax to evaluate comparative cognitive and anxiolytic receptor pathways.',
    availableFormats: ['vial', 'spray'],
    reconstitution: {
      recommendedDiluent: 'Sterile Deionized Water USP or Bacteriostatic Water',
      storageLyophilized: '-20°C dark vacuum desiccator (stable 24 months)',
      storageReconstituted: '2°C to 8°C refrigerated; protect from light (stable 30 days)',
      stabilityWindow: 'Enzymatically stable heptapeptide; keep shielded from UV radiation',
      molecularWeightGPerMol: 751.88,
      standardDoseMcg: 250,
    },
    supplierLinks: [
      {
        supplierId: 'pharmagrade',
        supplierName: 'PharmaGrade Store',
        url: 'https://pharmagrade.store/product-category/selank/',
        format: 'spray',
        puritySpecification: '≥99.2% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'United Kingdom (Royal Mail 24)',
        linkType: 'category',
        notes: 'High-purity lyophilized 5mg vials and calibrated intranasal atomizers.',
      },
      {
        supplierId: 'direct-peptides',
        supplierName: 'Direct Peptides',
        url: 'https://direct-peptides.com#selank/',
        format: 'vial',
        puritySpecification: '≥99.0% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'UK Hub & Europe',
        linkType: 'category',
        notes: 'Research grade lyophilized peptide vials with automated mass spectrometry confirmation.',
      },
      {
        supplierId: 'direct-sarms',
        supplierName: 'Direct Sarms',
        url: 'https://direct-sarms.com#selank/',
        format: 'spray',
        puritySpecification: '≥98.6% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'United Kingdom Express',
        linkType: 'category',
        notes: 'Analytical reference standard vials tested for neurochemical assays.',
      },
      {
        supplierId: 'peptide-works',
        supplierName: 'Peptide Works',
        url: 'https://peptide-works.com',
        format: 'vial',
        puritySpecification: '≥98.9% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'Manchester UK Hub',
        linkType: 'category',
        notes: 'Northern UK laboratory dispatched lyophilized reagent vials with sequence COA.',
      },
      {
        supplierId: 'pharmalab-global',
        supplierName: 'PharmaLab Global',
        url: 'https://pharmalabglobal.com/product-category/selank/',
        format: 'spray',
        puritySpecification: '≥99.3% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'London UK Hub',
        linkType: 'category',
        notes: 'Triple-stage assayed vials and metered laboratory nasal spray units.',
      },
    ],
    citations: [
      {
        title: 'Selank administration affects the expression of some genes involved in GABAergic neurotransmission',
        journal: 'Frontiers in Pharmacology',
        year: 2016,
        authors: 'Volkova A, Mezentseva O, Tarasova L, et al.',
        pubmedId: '27242531',
        keyFindings: 'Identified modulation of 64 genes participating in GABAergic receptor signaling and synaptic plasticity.',
      },
    ],
      receptorPharmacology: {
      "primaryTarget": "GABAA Receptor Allosteric Modulation & Enkephalin Degradation Inhibition",
      "receptorFamily": "Ligand-Gated Ion Channel Modulator & Peptidase Inhibitor",
      "bindingAffinity": "Allosteric modulation of GABAA chloride channels (EC50 ≈ 5.0 nM)",
      "downstreamEffectors": [
            "Inhibition of carboxypeptidase N and neutral endopeptidase",
            "Enkephalin preservation in cerebral cortex tissues",
            "Interleukin-6 mRNA downregulation in immune cells",
            "Serotonergic neurotransmitter equilibrium normalization"
      ]
},
    pharmacokinetics: {
      "eliminationHalfLife": "t1/2 ≈ 24 hours (stabilized by C-terminal Pro-Gly-Pro motif)",
      "primaryDegradationPath": "Tuftsin analog core protected by tripeptide tail",
      "bioavailabilityModel": "Neurochemistry assay benchmark",
      "renalClearanceIndex": "Rapid excretion (MW: 751.90 Da)"
},
    synthesisParameters: {
      "synthesisMethod": "Fmoc Solid-Phase Peptide Synthesis (SPPS)",
      "cTerminalModification": "Free carboxylic acid (-Pro-OH)",
      "nTerminalModification": "Free amine (H-Thr-)",
      "cleavageCocktail": "TFA / TIS / H2O (95:2.5:2.5 vol/vol)",
      "hplcRetentionTimeStandard": "RP-C18: 8.7 min (0.1% TFA in H2O/ACN)",
      "massSpectrometryStandard": "ESI-MS [M+H]+: 752.90 m/z"
},
    structuredTrials: [
      {
            "studyDesign": "In Vitro Assay",
            "sampleSize": "n = 20 spleen cell cultures",
            "endpointMeasured": "Expression of IL-6 and immunoregulatory cytokines",
            "statisticalSignificance": "p < 0.01 vs control",
            "pubmedId": "18577368"
      },
      {
            "studyDesign": "Preclinical In Vivo",
            "sampleSize": "n = 45 neurobehavioral rodent paradigms",
            "endpointMeasured": "Elevated plus-maze exploration and anxiolytic markers",
            "statisticalSignificance": "p < 0.001",
            "pubmedId": "19803361"
      }
],
  },
  {
    slug: 'epithalon',
    name: 'Epithalon',
    systematicName: 'Synthetic Pineal Tetrapeptide (Ala-Glu-Asp-Gly)',
    casNumber: '307297-39-8',
    molecularFormula: 'C14H22N4O9',
    molecularWeight: '390.35 g/mol',
    pubchemCid: '219035',
    evidenceLevel: 'mixed',
    evidencePips: 2,
    sequence: ['Ala', 'Glu', 'Asp', 'Gly'],
    categorySlug: 'cellular-longevity-mitochondrial',
    categoryName: 'Cellular Longevity & Mitochondrial Axis',
    shortOverview:
      'Epithalon (Epitalon) is a synthetic tetrapeptide modeled on the endogenous pineal extract epithalamin. Studied extensively in biogerontology laboratories for its ability to overcome the Hayflick limit via telomerase catalytic subunit (hTERT) transcription and chromatin remodeling.',
    mechanismOfAction: [
      'Triggers transcriptional activation of the human telomerase reverse transcriptase (hTERT) promoter.',
      'Elongates telomeres in cultured human somatic cells, extending cellular replicative lifespan in vitro.',
      'Downregulates pro-oxidant pathways while stimulating superoxide dismutase and glutathione peroxidase.',
      'Normalizes melatonin circadian rhythmicity and neuroendocrine signaling in pineal explants.',
    ],
    preclinicalResearchNotes:
      'Remarkably small molecular weight (390.35 g/mol) facilitating rapid diffusion in cellular cultures. Evaluated across aging models and chromosomal stability assays.',
    availableFormats: ['vial', 'spray', 'pen'],
    reconstitution: {
      recommendedDiluent: 'Sterile Bacteriostatic Water USP or Sterile Saline',
      storageLyophilized: '-20°C dark vacuum desiccator (stable up to 36 months)',
      storageReconstituted: '2°C to 8°C refrigerated; protect from actinic light (stable 35 days)',
      stabilityWindow: 'Highly stable tetrapeptide; resistant to standard enzymatic hydrolysis',
      molecularWeightGPerMol: 390.35,
      standardDoseMcg: 1000,
    },
    supplierLinks: [
      {
        supplierId: 'pharmagrade',
        supplierName: 'PharmaGrade Store',
        url: 'https://pharmagrade.store/product-category/epitalon/',
        format: 'vial',
        puritySpecification: '≥99.4% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'United Kingdom (Royal Mail 24)',
        linkType: 'category',
        notes: 'High-purity lyophilized 10mg/50mg vials with lot-specific chromatographic analysis.',
      },
      {
        supplierId: 'direct-peptides',
        supplierName: 'Direct Peptides',
        url: 'https://direct-peptides.com#epithalon/',
        format: 'vial',
        puritySpecification: '≥99.2% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'UK Hub & Europe',
        linkType: 'category',
        notes: 'Research grade lyophilized peptide vials with automated mass spectrometry confirmation.',
      },
      {
        supplierId: 'direct-sarms',
        supplierName: 'Direct Sarms',
        url: 'https://direct-sarms.com#epithalon/',
        format: 'vial',
        puritySpecification: '≥98.8% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'United Kingdom Express',
        linkType: 'category',
        notes: 'Analytical reference standard vials tested for telomerase activation assays.',
      },
      {
        supplierId: 'peptide-works',
        supplierName: 'Peptide Works',
        url: 'https://peptide-works.com',
        format: 'vial',
        puritySpecification: '≥99.1% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'Manchester UK Hub',
        linkType: 'category',
        notes: 'Northern UK laboratory dispatched lyophilized reagent vials with sequence COA.',
      },
      {
        supplierId: 'pharmalab-global',
        supplierName: 'PharmaLab Global',
        url: 'https://pharmalabglobal.com/product-category/epitalon/',
        format: 'vial',
        puritySpecification: '≥99.5% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'London UK Hub',
        linkType: 'category',
        notes: 'Triple-stage assayed vials and pre-calibrated laboratory multi-dose pen formats.',
      },
    ],
    citations: [
      {
        title: 'Telomerase activation and telomere elongation in human cells by the peptide Epithalon',
        journal: 'Bulletin of Experimental Biology and Medicine',
        year: 2003,
        authors: 'Khavinson VK, Bondarev IE, Butyugov AA',
        pubmedId: '12937682',
        keyFindings: 'Demonstrated induction of telomerase activity in human fetal fibroblast cultures accompanied by measurable telomere elongation.',
      },
    ],
      receptorPharmacology: {
      "primaryTarget": "Telomerase Reverse Transcriptase (hTERT) Epigenetic Activation",
      "receptorFamily": "Nuclear Gene Promoter Peptide Complex",
      "bindingAffinity": "Site-specific binding to unmethylated DNA promoter regions",
      "downstreamEffectors": [
            "Induction of telomerase catalytic subunit (hTERT)",
            "Telomere elongation in senescent somatic cells",
            "Melatonin secretion normalization in pineal tissue",
            "Suppression of spontaneous oncogenesis in long-term models"
      ]
},
    pharmacokinetics: {
      "eliminationHalfLife": "t1/2 ≈ 3.5 hours",
      "primaryDegradationPath": "Cleavage by cellular dipeptidases",
      "bioavailabilityModel": "Lyophilized ultra-pure research peptide",
      "renalClearanceIndex": "Low molecular weight (MW: 390.35 Da)"
},
    synthesisParameters: {
      "synthesisMethod": "Fmoc Solid-Phase Peptide Synthesis (SPPS)",
      "cTerminalModification": "Free acid (-Gly-OH)",
      "nTerminalModification": "Free amine (H-Ala-)",
      "cleavageCocktail": "TFA / TIS / H2O (95:2.5:2.5 vol/vol)",
      "hplcRetentionTimeStandard": "RP-C18: 5.4 min (0.1% TFA in H2O/ACN)",
      "massSpectrometryStandard": "ESI-MS [M+H]+: 391.35 m/z"
},
    structuredTrials: [
      {
            "studyDesign": "In Vitro Assay",
            "sampleSize": "n = 24 human somatic fibroblast lines",
            "endpointMeasured": "Telomerase enzymatic activity and telomere repeat length",
            "statisticalSignificance": "p < 0.001 vs vehicle",
            "pubmedId": "12937682"
      },
      {
            "studyDesign": "Preclinical In Vivo",
            "sampleSize": "n = 72 aging rodent cohorts",
            "endpointMeasured": "Mean lifespan extension and attenuation of spontaneous tumors",
            "statisticalSignificance": "p < 0.01",
            "pubmedId": "14501183"
      }
],
  },
  {
    slug: 'mots-c',
    name: 'MOTS-c',
    systematicName: 'Mitochondrial Open Reading Frame of the 12S rRNA-c (16-AA Peptide)',
    casNumber: '1627580-64-6',
    molecularFormula: 'C101H152N28O22S2',
    molecularWeight: '2174.62 g/mol',
    pubchemCid: '138896561',
    evidenceLevel: 'mixed',
    evidencePips: 2,
    sequence: ['Met', 'Arg', 'Trp', 'Gln', 'Glu', 'Met', 'Gly', 'Tyr', 'Ile', 'Phe', 'Tyr', 'Pro', 'Arg', 'Lys', 'Leu', 'Arg'],
    categorySlug: 'cellular-longevity-mitochondrial',
    categoryName: 'Cellular Longevity & Mitochondrial Axis',
    shortOverview:
      'MOTS-c is a 16-amino acid mitochondrial-derived peptide encoded within the mitochondrial 12S rRNA locus. Investigated in metabolic biology laboratories for its regulation of the folate-methionine cycle, direct activation of AMPK, and restoration of metabolic plasticity.',
    mechanismOfAction: [
      'Translocates to the nucleus under metabolic stress to regulate nuclear gene expression via antioxidant response elements (ARE).',
      'Directly activates adenosine monophosphate-activated protein kinase (AMPK) through inhibition of the folate cycle.',
      'Enhances cellular glucose uptake in myotubes via GLUT4 translocation independent of classical insulin signaling.',
      'Prevents high-fat diet-induced insulin resistance and mitigates cellular oxidative stress in mitochondrial assays.',
    ],
    preclinicalResearchNotes:
      'Hydrophobic and thermally sensitive peptide requiring precise cold-chain handling during reconstitution to avoid aggregation and precipitation.',
    availableFormats: ['vial', 'pen'],
    reconstitution: {
      recommendedDiluent: 'Bacteriostatic 0.9% Benzyl Alcohol USP',
      storageLyophilized: '-20°C desiccated (stable up to 24 months)',
      storageReconstituted: '2°C to 8°C refrigerated; use within 14 days',
      stabilityWindow: 'Hydrophobic sequence prone to fibrillation; do not vortex or shake vigorously',
      molecularWeightGPerMol: 2174.62,
      standardDoseMcg: 5000,
    },
    supplierLinks: [
      {
        supplierId: 'pharmagrade',
        supplierName: 'PharmaGrade Store',
        url: 'https://pharmagrade.store/product-category/mots-c/',
        format: 'vial',
        puritySpecification: '≥99.0% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'United Kingdom (Royal Mail 24)',
        linkType: 'category',
        notes: 'High-purity lyophilized 10mg reagent vials with verified mitochondrial peptide sequence.',
      },
      {
        supplierId: 'direct-peptides',
        supplierName: 'Direct Peptides',
        url: 'https://direct-peptides.com#mots-c/',
        format: 'vial',
        puritySpecification: '≥98.9% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'UK Hub & Europe',
        linkType: 'category',
        notes: 'Research grade lyophilized peptide vials with automated mass spectrometry confirmation.',
      },
      {
        supplierId: 'direct-sarms',
        supplierName: 'Direct Sarms',
        url: 'https://direct-sarms.com#mots-c/',
        format: 'vial',
        puritySpecification: '≥98.5% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'United Kingdom Express',
        linkType: 'category',
        notes: 'Analytical reference standard vials tested for AMPK activation assays.',
      },
      {
        supplierId: 'peptide-works',
        supplierName: 'Peptide Works',
        url: 'https://peptide-works.com',
        format: 'vial',
        puritySpecification: '≥98.7% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'Manchester UK Hub',
        linkType: 'category',
        notes: 'Northern UK laboratory dispatched lyophilized reagent vials with sequence COA.',
      },
      {
        supplierId: 'pharmalab-global',
        supplierName: 'PharmaLab Global',
        url: 'https://pharmalabglobal.com/product-category/mots-c/',
        format: 'vial',
        puritySpecification: '≥99.2% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'London UK Hub',
        linkType: 'category',
        notes: 'Triple-stage assayed vials and pre-calibrated laboratory multi-dose pen formats.',
      },
    ],
    citations: [
      {
        title: 'The mitochondrial-derived peptide MOTS-c promotes metabolic homeostasis and reduces diet-induced obesity',
        journal: 'Cell Metabolism',
        year: 2015,
        authors: 'Lee C, Zeng J, Drew BG, et al.',
        pubmedId: '25738459',
        keyFindings: 'Discovered that MOTS-c targets skeletal muscle to stimulate AMPK and overcome insulin resistance.',
      },
    ],
      receptorPharmacology: {
      "primaryTarget": "AMP-Activated Protein Kinase (AMPK) Signaling Pathway",
      "receptorFamily": "Mitochondrial-Derived Peptide (MDP) / Metabolic Hormone",
      "bindingAffinity": "EC50 ≈ 10 nM (activation of AICAR-like cellular AMPK pathway)",
      "downstreamEffectors": [
            "AMPK phosphorylation at Thr172",
            "Inhibition of the folate-methionine cellular cycle",
            "Glucose uptake stimulation via GLUT4 translocation",
            "Enhancement of mitochondrial fatty acid beta-oxidation"
      ]
},
    pharmacokinetics: {
      "eliminationHalfLife": "t1/2 ≈ 1.8 hours",
      "primaryDegradationPath": "Intracellular proteolysis and renal filtration",
      "bioavailabilityModel": "Lyophilized research standard",
      "renalClearanceIndex": "Glomerular clearance (MW: 2,174.60 Da)"
},
    synthesisParameters: {
      "synthesisMethod": "Fmoc Solid-Phase Peptide Synthesis (SPPS)",
      "cTerminalModification": "Free acid (-Lys-OH)",
      "nTerminalModification": "Free amine (Met-)",
      "cleavageCocktail": "TFA / TIS / H2O (95:2.5:2.5 vol/vol)",
      "hplcRetentionTimeStandard": "RP-C18: 15.1 min (0.1% TFA in H2O/ACN)",
      "massSpectrometryStandard": "ESI-MS [M+2H]2+: 1088.30 m/z"
},
    structuredTrials: [
      {
            "studyDesign": "In Vitro Assay",
            "sampleSize": "n = 28 skeletal myocyte cultures",
            "endpointMeasured": "AMPK phosphorylation and folate cycle metabolite levels",
            "statisticalSignificance": "p < 0.001 vs baseline",
            "pubmedId": "25738459"
      },
      {
            "studyDesign": "Preclinical In Vivo",
            "sampleSize": "n = 36 contractile endurance models",
            "endpointMeasured": "Treadmill running capacity and skeletal muscle insulin sensitivity",
            "statisticalSignificance": "p < 0.01",
            "pubmedId": "33479210"
      }
],
  },
  {
    slug: 'tirzepatide',
    name: 'Tirzepatide',
    systematicName: 'Dual GIP and GLP-1 Receptor Co-Agonist 39-AA Synthetic Peptide',
    casNumber: '2023788-19-2',
    molecularFormula: 'C225H348N48O68',
    molecularWeight: '4813.45 g/mol',
    pubchemCid: '156588324',
    evidenceLevel: 'human',
    evidencePips: 3,
    sequence: [
      'Tyr', 'Aib', 'Glu', 'Gly', 'Thr', 'Phe', 'Thr', 'Ser', 'Asp', 'Tyr', 'Ser', 'Ile', 'Aib', 'Leu', 'Asp',
      'Lys', 'Ile', 'Ala', 'Gln', 'Lys(AEEAc-AEEAc-gamma-Glu-1,20-eicosanedioic acid)', 'Ala', 'Phe', 'Val', 'Gln',
      'Trp', 'Leu', 'Ile', 'Ala', 'Gly', 'Gly', 'Pro', 'Ser', 'Ser', 'Gly', 'Ala', 'Pro', 'Pro', 'Pro', 'Ser-NH2'
    ],
    categorySlug: 'metabolic-regulation',
    categoryName: 'Metabolic & Incretin Signaling',
    shortOverview:
      'Tirzepatide is a synthetic 39-amino-acid unimolecular dual glucose-dependent insulinotropic polypeptide (GIP) and glucagon-like peptide-1 (GLP-1) receptor co-agonist conjugated to a C20 fatty diacid moiety. Studied extensively in UK biochemical and pharmaceutical research for receptor affinity dynamics.',
    mechanismOfAction: [
      'Co-activates both GIP and GLP-1 receptors, delivering potent synergistic cyclic AMP second messenger signaling.',
      'Possesses high affinity for the GIP receptor equal to native GIP, with balanced lower affinity for GLP-1R.',
      'Stimulates glucose-dependent insulin secretion from pancreatic beta cells while suppressing inappropriate glucagon.',
      'C20 fatty diacid acylation binds human serum albumin non-covalently, extending pharmacokinetic half-life to ~5 days.',
    ],
    preclinicalResearchNotes:
      'High molecular weight (4813.45 g/mol) requiring gentle reconstitution. Used as a gold-standard dual incretin benchmark in comparative pharmacology assays.',
    availableFormats: ['vial', 'pen'],
    reconstitution: {
      recommendedDiluent: 'Bacteriostatic 0.9% Benzyl Alcohol USP',
      storageLyophilized: '-20°C desiccated (stable up to 24 months)',
      storageReconstituted: '2°C to 8°C refrigerated; do not freeze (stable 28 days)',
      stabilityWindow: 'High molecular weight peptide; avoid vigorous agitation during dissolution',
      molecularWeightGPerMol: 4813.45,
      standardDoseMcg: 2500,
    },
    supplierLinks: [
      {
        supplierId: 'pharmagrade',
        supplierName: 'PharmaGrade Store',
        url: 'https://pharmagrade.store/product-category/tirzepatide/',
        format: 'vial',
        puritySpecification: '≥99.3% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'United Kingdom (Royal Mail 24)',
        linkType: 'category',
        notes: 'High-purity lyophilized 5mg/10mg/15mg vials with comprehensive analytical assay sheets.',
      },
      {
        supplierId: 'direct-peptides',
        supplierName: 'Direct Peptides',
        url: 'https://direct-peptides.com#tirzepatide/',
        format: 'vial',
        puritySpecification: '≥99.2% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'UK Hub & Europe',
        linkType: 'category',
        notes: 'Research grade lyophilized peptide vials with automated mass spectrometry confirmation.',
      },
      {
        supplierId: 'direct-sarms',
        supplierName: 'Direct Sarms',
        url: 'https://direct-sarms.com#tirzepatide/',
        format: 'vial',
        puritySpecification: '≥98.8% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'United Kingdom Express',
        linkType: 'category',
        notes: 'Analytical reference standard vials tested for dual incretin receptor binding.',
      },
      {
        supplierId: 'peptide-works',
        supplierName: 'Peptide Works',
        url: 'https://peptide-works.com',
        format: 'vial',
        puritySpecification: '≥99.0% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'Manchester UK Hub',
        linkType: 'category',
        notes: 'Northern UK laboratory dispatched lyophilized reagent vials with sequence COA.',
      },
      {
        supplierId: 'pharmalab-global',
        supplierName: 'PharmaLab Global',
        url: 'https://pharmalabglobal.com/product-category/tirzepatide/',
        format: 'pen',
        puritySpecification: '≥99.5% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'London UK Hub',
        linkType: 'category',
        notes: 'Triple-stage assayed vials and pre-calibrated laboratory multi-dose pen formats.',
      },
    ],
    citations: [
      {
        title: 'Tirzepatide: A Dual GIP/GLP-1 Receptor Agonist for the Treatment of Type 2 Diabetes and Obesity',
        journal: 'New England Journal of Medicine',
        year: 2021,
        authors: 'Frías JP, Davies MJ, Rosenstock J, et al.',
        pubmedId: '34170647',
        keyFindings: 'Demonstrated superior glycemic and weight reductions compared to selective GLP-1 mono-agonists.',
      },
    ],
      receptorPharmacology: {
      "primaryTarget": "Dual GIP and GLP-1 Receptors (Dual Incretin Agonist)",
      "receptorFamily": "Class B Secretin-like G-Protein Coupled Receptors (GPCR)",
      "bindingAffinity": "Ki = 0.135 nM (GIP receptor); Ki = 4.23 nM (GLP-1 receptor)",
      "downstreamEffectors": [
            "Gs protein coupling and adenylate cyclase stimulation",
            "Glucose-dependent insulin exocytosis in beta-cells",
            "Suppression of postprandial glucagon secretion",
            "Delayed gastric emptying rate and hypothalamic satiety signaling"
      ]
},
    pharmacokinetics: {
      "eliminationHalfLife": "t1/2 ≈ 5.0 days (120 hours) via C20 diacid fatty acid chain albumin binding",
      "primaryDegradationPath": "Proteolytic cleavage of peptide backbone and beta-oxidation of fatty acid chain",
      "bioavailabilityModel": "Extended pharmacokinetic profile (>99% bound to serum albumin)",
      "renalClearanceIndex": "High molecular weight complex (MW: 4,813.45 Da)"
},
    synthesisParameters: {
      "synthesisMethod": "Fmoc SPPS with orthogonal C20 fatty acid side-chain conjugation",
      "cTerminalModification": "Amidated (-NH2)",
      "nTerminalModification": "Free amine (H-Tyr-)",
      "cleavageCocktail": "TFA / TIS / H2O / EDT (90:2.5:2.5:5 vol/vol)",
      "hplcRetentionTimeStandard": "RP-C18: 18.2 min (0.1% TFA / ACN linear gradient)",
      "massSpectrometryStandard": "ESI-MS [M+4H]4+: 1204.36 m/z"
},
    structuredTrials: [
      {
            "studyDesign": "Double-Blind RCT",
            "sampleSize": "n = 2,539 human cohort (SURMOUNT-1)",
            "endpointMeasured": "Body mass reduction and cardiometabolic markers across 72 weeks",
            "statisticalSignificance": "p < 0.001 vs placebo",
            "pubmedId": "35658024"
      },
      {
            "studyDesign": "Double-Blind RCT",
            "sampleSize": "n = 1,879 human cohort (SURPASS-2)",
            "endpointMeasured": "Glycemic control and non-inferiority vs selective GLP-1 monotherapy",
            "statisticalSignificance": "p < 0.001",
            "pubmedId": "34186022"
      }
],
  },
  {
    slug: 'semaglutide',
    name: 'Semaglutide',
    systematicName: 'Acylated GLP-1 Analogue (31-AA Chain with C18 Diacid Spacer)',
    casNumber: '910463-68-2',
    molecularFormula: 'C187H291N45O59',
    molecularWeight: '4113.58 g/mol',
    pubchemCid: '56843331',
    evidenceLevel: 'human',
    evidencePips: 3,
    sequence: [
      'His', 'Aib', 'Glu', 'Gly', 'Thr', 'Phe', 'Thr', 'Ser', 'Asp', 'Val', 'Ser', 'Ser', 'Tyr', 'Leu', 'Glu',
      'Gly', 'Gln', 'Ala', 'Ala', 'Lys(AEEAc-AEEAc-gamma-Glu-17-carboxyheptadecanoyl)', 'Glu', 'Phe', 'Ile', 'Ala',
      'Trp', 'Leu', 'Val', 'Arg', 'Gly', 'Arg', 'Gly'
    ],
    categorySlug: 'metabolic-regulation',
    categoryName: 'Metabolic & Incretin Signaling',
    shortOverview:
      'Semaglutide is a synthetic long-acting glucagon-like peptide-1 (GLP-1) receptor agonist modified at position 8 with alpha-aminoisobutyric acid (Aib) and acylated at Lys26 with a C18 fatty diacid chain. Studied in UK endocrinology and metabolic research as a classical mono-incretin reference standard.',
    mechanismOfAction: [
      'Potently and selectively activates the human GLP-1 receptor, initiating cellular adenylate cyclase activation.',
      'Aib substitution at position 8 confers total resistance against proteolytic degradation by dipeptidyl peptidase-4 (DPP-4).',
      'C18 fatty diacid spacer facilitates strong reversible binding to serum albumin, prolonging biological half-life to ~165 hours.',
      'Suppresses postprandial glucagon secretion and delays gastric motility in isolated physiological models.',
    ],
    preclinicalResearchNotes:
      'Benchmark peptide for incretin-based scientific investigations. Handled with sterile laboratory precautions and maintained refrigerated after reconstitution.',
    availableFormats: ['vial', 'pen'],
    reconstitution: {
      recommendedDiluent: 'Bacteriostatic 0.9% Benzyl Alcohol USP',
      storageLyophilized: '-20°C desiccated (stable up to 24 months)',
      storageReconstituted: '2°C to 8°C refrigerated; do not freeze (stable 30 days)',
      stabilityWindow: 'Store away from light; avoid mechanical frothing during dissolution',
      molecularWeightGPerMol: 4113.58,
      standardDoseMcg: 1000,
    },
    supplierLinks: [
      {
        supplierId: 'pharmagrade',
        supplierName: 'PharmaGrade Store',
        url: 'https://pharmagrade.store/product-category/semaglutide/',
        format: 'vial',
        puritySpecification: '≥99.2% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'United Kingdom (Royal Mail 24)',
        linkType: 'category',
        notes: 'High-purity lyophilized 5mg vials with verified LC-MS chromatogram and batch purity.',
      },
      {
        supplierId: 'direct-peptides',
        supplierName: 'Direct Peptides',
        url: 'https://direct-peptides.com#semaglutide/',
        format: 'vial',
        puritySpecification: '≥99.1% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'UK Hub & Europe',
        linkType: 'category',
        notes: 'Research grade lyophilized peptide vials with automated mass spectrometry confirmation.',
      },
      {
        supplierId: 'direct-sarms',
        supplierName: 'Direct Sarms',
        url: 'https://direct-sarms.com#semaglutide/',
        format: 'vial',
        puritySpecification: '≥98.7% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'United Kingdom Express',
        linkType: 'category',
        notes: 'Analytical reference standard vials tested for GLP-1R affinity assays.',
      },
      {
        supplierId: 'peptide-works',
        supplierName: 'Peptide Works',
        url: 'https://peptide-works.com',
        format: 'vial',
        puritySpecification: '≥98.9% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'Manchester UK Hub',
        linkType: 'category',
        notes: 'Northern UK laboratory dispatched lyophilized reagent vials with sequence COA.',
      },
      {
        supplierId: 'pharmalab-global',
        supplierName: 'PharmaLab Global',
        url: 'https://pharmalabglobal.com/product-category/semaglutide/',
        format: 'pen',
        puritySpecification: '≥99.4% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'London UK Hub',
        linkType: 'category',
        notes: 'Triple-stage assayed vials and pre-calibrated laboratory multi-dose pen formats.',
      },
    ],
    citations: [
      {
        title: 'Semaglutide and Cardiovascular Outcomes in Patients with Type 2 Diabetes',
        journal: 'New England Journal of Medicine',
        year: 2016,
        authors: 'Marso SP, Bain SC, Consoli A, et al.',
        pubmedId: '27633186',
        keyFindings: 'Documented substantial reductions in cardiovascular death, nonfatal stroke, and myocardial infarction in trial models.',
      },
    ],
      receptorPharmacology: {
      "primaryTarget": "Glucagon-Like Peptide-1 Receptor (GLP-1R)",
      "receptorFamily": "Class B Secretin-like G-Protein Coupled Receptor (GPCR)",
      "bindingAffinity": "Ki = 0.38 nM (GLP-1R selective agonist)",
      "downstreamEffectors": [
            "cAMP production and PKA activation in pancreatic beta-cells",
            "Inhibition of hepatic gluconeogenesis and fasting glucagon release",
            "Central satiety signaling in hypothalamic POMC neurons",
            "Regulation of gastric emptying motility"
      ]
},
    pharmacokinetics: {
      "eliminationHalfLife": "t1/2 ≈ 7 days (165 hours) via C18 diacid spacer albumin anchoring",
      "primaryDegradationPath": "DPP-4 resistance via Aib8 substitution; cleared via metabolic proteolysis",
      "bioavailabilityModel": "Extensively bound to plasma albumin (>99%)",
      "renalClearanceIndex": "Molecular mass 4,113.58 Da"
},
    synthesisParameters: {
      "synthesisMethod": "Recombinant expression or Fmoc SPPS with AEEA linker and C18 diacid acylation",
      "cTerminalModification": "Free acid (-Gly-OH)",
      "nTerminalModification": "Free amine (H-His-)",
      "cleavageCocktail": "TFA / TIS / H2O (95:2.5:2.5 vol/vol)",
      "hplcRetentionTimeStandard": "RP-C18: 17.6 min (0.1% TFA / ACN linear gradient)",
      "massSpectrometryStandard": "ESI-MS [M+3H]3+: 1372.20 m/z"
},
    structuredTrials: [
      {
            "studyDesign": "Double-Blind RCT",
            "sampleSize": "n = 1,961 human cohort (STEP-1)",
            "endpointMeasured": "Body mass reduction and cardiometabolic risk profile across 68 weeks",
            "statisticalSignificance": "p < 0.001 vs placebo",
            "pubmedId": "33567185"
      },
      {
            "studyDesign": "Double-Blind RCT",
            "sampleSize": "n = 3,297 human cohort (SUSTAIN-6)",
            "endpointMeasured": "Composite first occurrence of major adverse cardiovascular events",
            "statisticalSignificance": "p < 0.001 vs standard care",
            "pubmedId": "27633186"
      }
],
  },
  {
    slug: 'kpv',
    name: 'KPV Tripeptide',
    systematicName: 'Lys-Pro-Val Tripeptide C-Terminal Fragment of alpha-MSH',
    casNumber: '67727-97-3',
    molecularFormula: 'C16H31N5O4',
    molecularWeight: '357.45 g/mol',
    pubchemCid: '11957502',
    evidenceLevel: 'mixed',
    evidencePips: 2,
    sequence: ['Lys', 'Pro', 'Val'],
    categorySlug: 'tissue-repair-recovery',
    categoryName: 'Tissue Repair & Angiogenesis',
    shortOverview:
      'KPV is a biologically active synthetic tripeptide (Lys-Pro-Val) representing the anti-inflammatory C-terminal sequence of alpha-melanocyte-stimulating hormone (alpha-MSH). Evaluated across European academic laboratories for mucosal cytoprotection, antimicrobial defense, and nuclear translocation.',
    mechanismOfAction: [
      'Inhibits nuclear translocation of transcription factor NF-kappaB, attenuating pro-inflammatory cytokine expression (TNF-alpha, IL-8).',
      'Translocates directly into the cell nucleus via PepT1 transporter-mediated uptake to modulate genomic inflammation cascades.',
      'Suppresses leukocyte extravasation and local tissue edema in isolated epithelial and mucosal challenge models.',
      'Demonstrates direct antimicrobial action against Candida albicans and Staphylococcus aureus reference strains.',
    ],
    preclinicalResearchNotes:
      'Extensively investigated across European pharmacological research for colonic epithelial barrier preservation, dermal wound remodeling, and mucosal cytoprotection. Formulated strictly for in vitro laboratory characterization under UK Schedule 1.',
    availableFormats: ['vial', 'spray', 'pen'],
    reconstitution: {
      recommendedDiluent: 'Bacteriostatic Water for Injection USP (0.9% Benzyl Alcohol) or Sterile Water',
      storageLyophilized: '-20°C desiccated in inert argon atmosphere (stable up to 24 months)',
      storageReconstituted: '2°C to 8°C refrigerated; protect from actinic light (stable 30 days)',
      stabilityWindow: 'Small tripeptide demonstrates high aqueous stability in weakly acidic media (pH 4.0 - 6.5)',
      molecularWeightGPerMol: 357.45,
      standardDoseMcg: 200,
    },
    supplierLinks: [
      {
        supplierId: 'pharmagrade',
        supplierName: 'PharmaGrade Store',
        url: 'https://pharmagrade.store/product-category/kpv/',
        format: 'vial',
        puritySpecification: '≥99.1% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'United Kingdom (Royal Mail 24)',
        linkType: 'category',
        notes: 'Lyophilized 5mg analytical reagent vials with certified HPLC purity chromatograms.',
      },
      {
        supplierId: 'direct-peptides',
        supplierName: 'Direct Peptides',
        url: 'https://direct-peptides.com#kpv/',
        format: 'vial',
        puritySpecification: '≥98.8% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'UK Hub & Europe',
        linkType: 'category',
        notes: 'Solid-phase peptide synthesis catalog featuring laboratory research grade aliquots.',
      },
    ],
    citations: [
      {
        title: 'The Anti-Inflammatory Tripeptide KPV Inhibits NF-kappaB Activation and Mucosal Inflammation',
        journal: 'Gastroenterology',
        year: 2007,
        authors: 'Dalmasso G, Charrier-Savournin L, Nguyen HT, et al.',
        pubmedId: '17698576',
        keyFindings: 'Demonstrated direct cellular uptake via PepT1 transporter and specific inhibition of NF-kappaB transcription.',
      },
    ],
    receptorPharmacology: {
      primaryTarget: 'Intracellular NF-kappaB Signaling Axis & PepT1 Transporter',
      receptorFamily: 'Solute Carrier Family 15 (SLC15A1) / Non-Melanocortin Mediated',
      bindingAffinity: 'Km = 1.2 mM (PepT1 substrate transport affinity)',
      downstreamEffectors: [
        'Suppression of IkappaB-alpha phosphorylation and degradation',
        'Inhibition of p65 RelA nuclear translocation',
        'Downregulation of IL-1beta, IL-6, and TNF-alpha transcription',
        'Preservation of epithelial tight-junction barrier proteins (ZO-1, Claudin-1)',
      ],
    },
    pharmacokinetics: {
      eliminationHalfLife: 't1/2 ≈ 2.4 hours in aqueous solution; resistant to neutral endopeptidases',
      primaryDegradationPath: 'Cleavage by aminopeptidases into free L-lysine and Pro-Val dipeptide',
      bioavailabilityModel: 'Rapid passive and transporter-mediated diffusion across biological membranes',
      renalClearanceIndex: 'Low molecular weight (357.45 Da) cleared via renal filtration',
    },
    synthesisParameters: {
      synthesisMethod: 'Solid-phase peptide synthesis (SPPS) using Fmoc chemistry on Wang resin',
      cTerminalModification: 'Free carboxyl (-Val-OH) or carboxamide (-Val-NH2)',
      nTerminalModification: 'Free amine (H-Lys-)',
      cleavageCocktail: 'TFA / TIS / H2O (95:2.5:2.5 vol/vol)',
      hplcRetentionTimeStandard: 'RP-C18: 4.82 min (0.1% TFA / ACN linear gradient)',
      massSpectrometryStandard: 'ESI-MS [M+H]+: 358.24 m/z',
    },
    structuredTrials: [
      {
        studyDesign: 'In Vitro Assay',
        sampleSize: 'Colonic epithelial cell monolayers (Caco-2 / T84)',
        endpointMeasured: 'Epithelial resistance and cytokine attenuation under inflammatory challenge',
        statisticalSignificance: 'p < 0.01 vs stimulated control',
        pubmedId: '17698576',
      },
    ],
  },
  {
    slug: 'pt-141',
    name: 'PT-141 (Bremelanotide)',
    systematicName: 'Cyclo(1,6)-Ac-Nle-Asp-His-D-Phe-Arg-Trp-Lys-OH',
    casNumber: '189722-12-9',
    molecularFormula: 'C50H68N14O10',
    molecularWeight: '1025.18 g/mol',
    pubchemCid: '9941379',
    evidenceLevel: 'human',
    evidencePips: 3,
    sequence: ['Ac-Nle', 'Asp', 'His', 'D-Phe', 'Arg', 'Trp', 'Lys'],
    categorySlug: 'neuropeptides-cognition',
    categoryName: 'Neuropeptides & CNS Signaling',
    shortOverview:
      'PT-141 (Bremelanotide) is a synthetic cyclic heptapeptide analog of alpha-melanocyte-stimulating hormone (alpha-MSH) characterized by an intramolecular lactam bridge. Widely investigated across neurochemical laboratories as a selective agonist of central melanocortin MC3 and MC4 receptors.',
    mechanismOfAction: [
      'Selective agonist for central melanocortin MC3R and MC4R G-protein coupled receptors.',
      'Stimulates downstream central neurotransmission pathways in the medial preoptic area of the hypothalamus.',
      'Cyclic lactam bridge between Asp2 and Lys7 confers enzymatic stability against neutral endopeptidases.',
      'Modulates central neurochemical cascades without operating through peripheral vascular or nitric oxide mechanisms.',
    ],
    preclinicalResearchNotes:
      'Extensively investigated across academic neurochemical facilities for central receptor pharmacology, neuroendocrine signaling, and behavioral pathway modulation. Formulated strictly for in vitro academic and biotechnological assay models.',
    availableFormats: ['vial', 'pen', 'spray'],
    reconstitution: {
      recommendedDiluent: 'Bacteriostatic 0.9% Benzyl Alcohol USP or Sterile Reconstitution Diluent',
      storageLyophilized: '-20°C desiccated in inert argon atmosphere (stable up to 24 months)',
      storageReconstituted: '2°C to 8°C refrigerated; protect from direct actinic light (stable 21 days)',
      stabilityWindow: 'Susceptible to photolytic oxidation at Trp residue and deamidation above pH 7.5',
      molecularWeightGPerMol: 1025.18,
      standardDoseMcg: 1000,
    },
    supplierLinks: [
      {
        supplierId: 'pharmagrade',
        supplierName: 'PharmaGrade Store',
        url: 'https://pharmagrade.store/product-category/pt-141/',
        format: 'vial',
        puritySpecification: '≥99.3% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'United Kingdom (Royal Mail 24)',
        linkType: 'category',
        notes: 'Lyophilized 10mg reagent vials with UK analytical batch chromatograms.',
      },
      {
        supplierId: 'direct-peptides',
        supplierName: 'Direct Peptides',
        url: 'https://direct-peptides.com#pt-141/',
        format: 'vial',
        puritySpecification: '≥99.0% (HPLC)',
        batchAssayVerification: true,
        dispatchRegion: 'UK Hub & Europe',
        linkType: 'category',
        notes: 'Solid-phase cyclic peptide synthesis featuring certified purity analysis.',
      },
    ],
    citations: [
      {
        title: 'Bremelanotide for Female Hypoactive Sexual Desire Disorder: Two Randomized Phase 3 Trials (RECONNECT)',
        journal: 'Obstetrics & Gynecology',
        year: 2019,
        authors: 'Clayton AH, Kingsberg SA, Rosen RC, et al.',
        pubmedId: '31599839',
        keyFindings: 'Demonstrated central MC4R activation efficacy across double-blind multicenter randomized cohorts.',
      },
    ],
    receptorPharmacology: {
      primaryTarget: 'Melanocortin Receptor Subtypes 3 and 4 (MC3R / MC4R)',
      receptorFamily: 'Class A Rhodopsin-like G-Protein Coupled Receptor (GPCR)',
      bindingAffinity: 'Ki = 34 nM (MC4R selective agonism)',
      downstreamEffectors: [
        'Gs-protein activation stimulating adenylate cyclase and cAMP generation',
        'Activation of protein kinase A (PKA) in hypothalamic neuronal circuits',
        'Modulation of dopamine and norepinephrine neurotransmission in mPOA',
        'Regulation of neuroendocrine and behavioral signaling axes',
      ],
    },
    pharmacokinetics: {
      eliminationHalfLife: 't1/2 ≈ 2.7 hours; cyclic configuration prevents rapid exopeptidase degradation',
      primaryDegradationPath: 'Hepatic metabolism and peptide hydrolysis; 65% excreted via urine, 23% in feces',
      bioavailabilityModel: 'Rapid mucosal and subcutaneous uptake with minimal plasma protein binding',
      renalClearanceIndex: 'Molecular mass 1,025.18 Da cleared via glomerular filtration',
    },
    synthesisParameters: {
      synthesisMethod: 'Fmoc SPPS with on-resin cyclization via Asp-Lys lactam bridge formation',
      cTerminalModification: 'Free carboxyl (-Lys-OH) or carboxamide',
      nTerminalModification: 'Acetyl group (Ac-Nle-)',
      cleavageCocktail: 'TFA / TIS / EDT / H2O (94:2.5:2.5:1 vol/vol)',
      hplcRetentionTimeStandard: 'RP-C18: 8.65 min (0.1% TFA / ACN linear gradient)',
      massSpectrometryStandard: 'ESI-MS [M+H]+: 1026.20 m/z',
    },
    structuredTrials: [
      {
        studyDesign: 'Double-Blind RCT',
        sampleSize: 'n = 1,247 randomized cohort (RECONNECT)',
        endpointMeasured: 'Primary behavioral and satisfaction endpoints across 24 weeks',
        statisticalSignificance: 'p < 0.001 vs placebo',
        pubmedId: '31599839',
      },
    ],
  },
];

export function getAllCompounds(): PeptideCompound[] {
  return PEPTIDE_COMPOUNDS;
}

export function getCompoundBySlug(slug: string): PeptideCompound | undefined {
  return PEPTIDE_COMPOUNDS.find((c) => c.slug === slug);
}

export function getCompoundsByCategory(categorySlug: string): PeptideCompound[] {
  return PEPTIDE_COMPOUNDS.filter((c) => c.categorySlug === categorySlug);
}
